export const ValidationUtil = {

    /**
     * Remove leading and trailing blanks on all input fields.
     */
    trimTextFields(formValues) {
        Object.keys(formValues).forEach((key) => {
            if (typeof formValues[key] === "string") {
                formValues[key] = formValues[key].trim(); // Trim whitespace
            }
        });
    },


    /**
     * Validate required form fields and show errors in the form erros class
     */
    required(formValues, formErrors, requiredFields) {
        let isValid = true;

        requiredFields.forEach(field => {

            const value = formValues[field];

            if (!value) {
                formErrors[field] = `Eingabe ist erforderlich.`;
                isValid = false;
            } else if (value === -1) {
                formErrors[field] = `Auswahl ist erforderlich.`;
                isValid = false;
            } else if (Array.isArray(value) && value.length === 0) {
                formErrors[field] = `Auswahl ist erforderlich.`;
                isValid = false;
            } else {
                formErrors[field] = ""; // Clear previous error if valid
            }
        });

        return isValid;
    },

    /**
     * Validate text input of the given field for a valid number.
     * No leading zero's like 000, 001 are allowed.
     */
    number(formValues, formErrors, field) {

        // Check if the input is empty
        if (formValues[field] === "") {
           formErrors[field] = 'Eingabe einer gültigen Zahl ist erforderlich.';
            return false;
        }

        // Regular expression to match a valid number (no leading zeros, except "0")
        const validNumberPattern = /^(0|[1-9][0-9]*)$/;

        if (!validNumberPattern.test(formValues[field])) {
            formErrors[field] = 'Format ist ungültig. Eingabe einer gültigen Zahl ist erforderlich.';
            return false;
        }

        return true;
    },

    minLength(formValues, formErrors, minimalLengthFields) {
        let isValid = true;

        Object.keys(minimalLengthFields).forEach(field => {
            const minLength = minimalLengthFields[field];
            const value = formValues[field];

            if (value && value.length < minLength) {
                formErrors[field] = `Eingabe muss mindestens ${minLength} Zeichen lang sein.`;
                isValid = false;
            } else {
                formErrors[field] = ""; // Clear previous error if valid
            }
        });

        return isValid;
    },

    areEqual(formValues, initialValues) {
        return Object.keys(formValues).every(key => formValues[key] === initialValues[key]);
    },

    dateRange(formValues, formErrors, startDateField, endDateField) {
        if (formValues[startDateField] && formValues[endDateField]) {

            const startDate = new Date(formValues[startDateField]);
            const endDate = new Date(formValues[endDateField]);

            if (endDate < startDate) {
                formErrors[endDateField] = "Enddatum muss gleich oder später als Startdatum sein.";
                return false;
            } else {
                formErrors[endDateField] = ""; // Clear previous error if valid
            }
        }
        return true;
    },

    numberRange(formValues, formErrors, numberFrom, numberTo) {
        const from = Number(formValues[numberFrom]);
        const to   = Number(formValues[numberTo]);

        if (!isNaN(from) && !isNaN(to)) {
            if (to < from) {
                formErrors[numberTo] = "Endwert muss grösser oder gleich Startwert sein.";
                return false;
            } else {
                formErrors[numberTo] = "";
            }
        }
        return true;
    },

    toArray(values) {
        try {
            if (Array.isArray(values)) {
                return values;
            }

            if (typeof values === "string" && values.trim() !== "") {
                return JSON.parse(values);
            }
        } catch (e) {
            console.log("toArray failed with:", e);
        }
        return [];
    },

    containEqualIds(mainValues, extValues) {
        const mainArray = this.toArray(mainValues);
        const extArray = this.toArray(extValues);

        const mainStr = [...(mainArray)]
            .map(Number)
            .sort((a, b) => a - b)
            .join(',');

        const extStr = [...(extArray)]
            .map(Number)
            .sort((a, b) => a - b)
            .join(',');

        return mainStr === extStr;
    }

};
